import { Component, OnInit } from '@angular/core';
import { UserService } from '../services/user/user.service';
import { ForuscareService } from '../services/foruscare/foruscare.service';

declare var $: any;
declare var grecaptcha: any;
declare var window: any;

@Component({
  selector: 'app-recoverpwd',
  templateUrl: './recoverpwd.component.html',
  styleUrls: ['./recoverpwd.component.css']
})
export class RecoverpwdComponent implements OnInit {
  emailToReset: string;
  emailSent: boolean = false;
  message: String = null;
  manualCaptcha: boolean = false;

  constructor(public userService: UserService,
    public foruscareService: ForuscareService
  ) { }

  ngOnInit() {
    this.manualCaptcha = false;
  }

  // pwdRecoverSubmit() {
  //   this.userService.sendResetPasswordLink(this.emailToReset)
  //     .subscribe(response => {
  //       this.emailSent = true;
  //       if (response.errorCode == 200) {
  //         if (response.data != null) {
  //           this.message = "Please check your mail to proceed further.";
  //         }
  //         else {
  //           this.message = "We couldn't find account with provided email address.";
  //         }
  //       }
  //       else {
  //         this.message = "We couldn't find account with provided email address.";
  //       }
  //     });
  // }

  pwdRecoverSubmit() {

    if (this.foruscareService.getActiveEnv() == "STGTELEEYE" || this.foruscareService.getActiveEnv() == "LIVE") {
      let componentRef = this;
      grecaptcha.enterprise.ready(function () {
        grecaptcha.enterprise.execute(componentRef.foruscareService.getCaptchaSiteKey(), { action: 'login' }).then(function (token: any) {
          let captchaElement: any = document.getElementById('g-recaptcha-token');
          if (captchaElement != null) {
            captchaElement.value = token;
          }
          if (token) {
            let emailPayload = {
              userId: componentRef.emailToReset,
              captchaToken: token,
              manualCaptcha: false
            };
            componentRef.userService.sendResetPasswordLinkWithCaptcha(emailPayload)
              .subscribe(response => {
                if (response.errorCode == 200) {
                  if (response.data != null) {
                    componentRef.message = "Please check your mail to proceed further.";
                  }
                  else {
                    componentRef.message = "We couldn't find account with provided email address.";
                  }
                }
                else {
                  componentRef.message = "We couldn't find account with provided email address.";
                }
              });
          }
          else {
            componentRef.foruscareService.showNotification("Invalid captcha !", "danger");
          }
        });
      });
    }
    else {
      this.userService.sendResetPasswordLink(this.emailToReset)
        .subscribe(response => {
          this.emailSent = true;
          if (response.errorCode == 200) {
            if (response.data != null) {
              this.message = "Please check your mail to proceed further.";
            }
            else {
              this.message = "We couldn't find account with provided email address.";
            }
          }
          else {
            this.message = "We couldn't find account with provided email address.";
          }
        });
    }
  }

}
